var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'tag-label': true,
    'tag-label-warning': _vm.label.level === 'WARN',
    'tag-label-error': _vm.label.level === 'ERROR',
  },on:{"click":function (e) { return (_vm.label.toast ? _vm.showDetail(_vm.label.toast, e) : null); }}},[_vm._t("title",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.label.name || _vm.label.title))])]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }